import React from 'react';

const NoRecordFound = ({ 
  message = 'No records found', 
  subMessage = 'Try adjusting your search or filter to find what you\'re looking for.',
  icon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  )
}) => (
  <div className="flex flex-col items-center justify-center p-8 text-center">
    <div className="bg-gray-100 dark:bg-gray-800 rounded-full p-5 mb-4 text-gray-500 dark:text-gray-400">
      {icon}
    </div>
    <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-1">
      {message}
    </h3>
    <p className="text-sm text-gray-500 dark:text-gray-400 max-w-md">
      {subMessage}
    </p>
  </div>
);

export default NoRecordFound;